import axios from "axios";
import { AUTH_SESSION_EXPIRED_MESSAGE, isAuthSessionExpiredError } from "../auth/auth0Config";

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  "https://854ween5x9.execute-api.us-east-1.amazonaws.com/prod/";

let accessTokenGetter = null;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

export function apiErrorMessage(error) {
  if (isAuthSessionExpiredError(error)) return AUTH_SESSION_EXPIRED_MESSAGE;
  const data = error?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message) return data.message;
  if (data?.error) return data.error;
  if (error?.message) return error.message;
  return "Request failed";
}

api.interceptors.request.use(async (config) => {
  if (!accessTokenGetter) {
    return config;
  }
  const token = await accessTokenGetter();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    error.displayMessage = apiErrorMessage(error);
    return Promise.reject(error);
  }
);

export function setAccessTokenGetter(getter) {
  accessTokenGetter = getter;
}

export { API_BASE };
export default api;
